export const MAP_FIELDS_IN_CSV = [
	{
		from: 'Kampania',
		to: 'campaign',
	},
	{
		from: 'Dzień',
		to: 'date',
	},
	{
		from: 'Kod waluty',
		to: 'currency',
	},
	{
		from: 'Koszt',
		to: 'cost',
	},
];
